import { GridSize } from '@material-ui/core';

export enum EFormTags {
  textField,
  whatsapp,
  currency,
  select,
}

export type IOption = {
  value: any;
  label: string;
};

export type IFormItem = {
  tag: EFormTags;
  label: string;
  name: string;
  type?: string;
  margin?: 'normal' | 'dense' | 'none';
  options?: IOption[];
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
};

export type IFormSection = {
  id: string;
  title?: string;
  items: IFormItem[];
};
